"use client";

import type { FC, Ref } from "react";
import { AnalysisSummary, type AnalysisSummaryProps } from "@huub-web/shared";

export interface AnalysisSummaryTemplateProps {
  body?: AnalysisSummaryProps["summary"];
  grade?: AnalysisSummaryProps["grade"];
  impression?: AnalysisSummaryProps["impression"];
}

/**
 * @deprecated
 */
export const AnalysisSummaryTemplate: FC<
  AnalysisSummaryTemplateProps & { ref?: Ref<HTMLDivElement> }
> = ({ body, grade, impression, ref }) => (
  <AnalysisSummary
    ref={ref}
    container="default"
    summary={body}
    grade={grade}
    impression={impression}
  />
);
